import type { EnqueueSnackbar } from "notistack";
import { IPartnerDto } from "src/shared/types/partner.types";
import { INTEGRATION_1C_MESSAGES } from "../model/constants";
import { getIntegration1CStatus } from "./GetIntegration1CStatus";

type TIntegration1c = IPartnerDto["integration_1c"];

export const notifyIntegration1C = (
  enqueueSnackbar: EnqueueSnackbar,
  integration_1c: TIntegration1c,
) => {
  const status = getIntegration1CStatus(integration_1c);

  const msg = INTEGRATION_1C_MESSAGES[status];

  enqueueSnackbar(msg.text, { variant: msg.variant });
};
